import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const HighlightsComponent = lazy(() =>
  import("@/modules/insights/pages/highlights").then((module) => ({
    default: module.HighlightsTab,
  }))
);

export const Route = createFileRoute("/(auth)/_headed/insights/_layout/")({
  component: HighlightsComponent,
});
